export default __webpack_public_path__ + "static/low-rate-card-w-illustrations-2ac6065b7847b35d24bb117fe2d3c23f.png";